import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 16px;
  border-radius: 16px;

  display: flex;
  width: 50%;
  background: #edf0f5;
`;
